import React, { useState } from 'react';
import { Card, Form, Button, Spinner, Container } from 'react-bootstrap';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { resetPassword } from './api';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!token) {
      toast.error('Token de restablecimiento faltante en la URL.');
      return;
    }

    if (password.length < 6) {
      toast.error('La contraseña debe tener al menos 6 caracteres.');
      return;
    }

    if (password !== confirmPassword) {
      toast.error('Las contraseñas no coinciden.');
      return;
    }

    setLoading(true);
    try {
      await resetPassword(token, password);
      toast.success('¡Contraseña restablecida con éxito!');
      setIsSuccess(true);
    } catch (error) {
      setLoading(false);
    }
  };

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  if (isSuccess) {
    return (
      <Container className="d-flex align-items-center justify-content-center min-vh-100" style={{ backgroundColor: '#121212' }}>
        <Card className="p-4 shadow border-0 text-center" style={{ width: '400px', backgroundColor: '#1e1e1e', color: '#ffffff' }}>
          <Card.Body>
            <div className="text-success mb-4" style={{ fontSize: '3rem' }}>
              ✔️
            </div>
            <h3 className="fw-bold mb-3">Contraseña Actualizada</h3>
            {isMobile ? (
              <>
                <p className="text-muted small mb-4">
                  Tu clave ha sido restablecida con éxito. Ya puedes cerrar esta pestaña de tu navegador e ingresar a la aplicación <strong>EmiGo</strong> instalada en tu celular.
                </p>
                <Button 
                  variant="primary" 
                  className="w-100 fw-bold py-2 mb-2" 
                  onClick={() => {
                    // Intentar abrir la app nativa a través del esquema de Capacitor/DeepLink
                    window.location.href = "emigo://";
                    setTimeout(() => {
                      window.close();
                    }, 500);
                  }}
                >
                  Abrir App EmiGo
                </Button>
                <p className="text-muted" style={{ fontSize: '0.75rem' }}>
                  Si el botón no abre la app, simplemente ábrela de forma manual desde tu celular.
                </p>
              </>
            ) : (
              <>
                <p className="text-muted small mb-4">
                  Tu clave ha sido restablecida con éxito. Haz clic en el botón de abajo para ir al inicio de sesión.
                </p>
                <Button variant="primary" className="w-100 fw-bold py-2" onClick={() => navigate('/login')}>
                  Ir al Inicio de Sesión
                </Button>
              </>
            )}
          </Card.Body>
        </Card>
      </Container>
    );
  }

  if (!token) {
    return (
      <Container className="d-flex align-items-center justify-content-center min-vh-100" style={{ backgroundColor: '#121212' }}>
        <Card className="p-4 shadow border-0 text-center" style={{ width: '400px', backgroundColor: '#1e1e1e', color: '#ffffff' }}>
          <Card.Body>
            <h3 className="text-danger mb-3">⚠️ Enlace Inválido</h3>
            <p className="text-muted">El enlace de recuperación es incorrecto o le falta el token de verificación.</p>
            <Button variant="outline-primary" onClick={() => navigate('/login')} className="w-100 mt-2">
              Volver al Login
            </Button>
          </Card.Body>
        </Card>
      </Container>
    );
  }

  return (
    <Container className="d-flex align-items-center justify-content-center min-vh-100" style={{ backgroundColor: '#121212' }}>
      <Card className="p-4 shadow border-0" style={{ width: '400px', backgroundColor: '#1e1e1e', color: '#ffffff' }}>
        <Card.Body>
          <div className="text-center mb-4">
            <h3 className="fw-bold">Nueva Contraseña</h3>
            <p className="text-muted small">Ingrese su nueva clave de acceso para actualizar la cuenta.</p>
          </div>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label className="text-muted small">Nueva Contraseña</Form.Label>
              <Form.Control
                type="password"
                required
                placeholder="Mínimo 6 caracteres"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ backgroundColor: '#2d2d2d', color: '#ffffff', borderColor: '#444444' }}
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="text-muted small">Confirmar Contraseña</Form.Label>
              <Form.Control
                type="password"
                required
                placeholder="Repita la contraseña"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                style={{ backgroundColor: '#2d2d2d', color: '#ffffff', borderColor: '#444444' }}
              />
            </Form.Group>

            <Button type="submit" variant="primary" className="w-100 fw-bold py-2" disabled={loading}>
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" role="status" className="me-2" />
                  Actualizando...
                </>
              ) : (
                'Establecer Contraseña'
              )}
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ResetPassword;
